export const comments_3278343 = {"data":{"data":[],"links":{}}}